import { Typography } from '@mui/material';
import { bagStatuses } from '@/constants/Bag';
import { useTranslate } from 'react-admin';

export const FillingTimeField = ({ record }) => {
    const translate = useTranslate();
    if (!record) return null;
    const fillingTimeInProgress = new Date() - new Date(record.createdAt) || 0;
    const fillingTimeCollected = new Date(record.sealScanningTime) - new Date(record.createdAt) || 0;

    const daysInProgress = Math.round(fillingTimeInProgress / (1000 * 60 * 60 * 24));
    const daysCollected = Math.round(fillingTimeCollected / (1000 * 60 * 60 * 24));

    return (
        <Typography variant='body2' className={record.status === bagStatuses.in_progress ? 'gray' : ''}>
            {record.status === bagStatuses.in_progress
                ? `${daysInProgress} ${daysInProgress === 1 ? translate('analytics.common.daySingular') : translate('analytics.common.days')}`
                : `${daysCollected} ${daysCollected === 1 ? translate('analytics.common.daySingular') : translate('analytics.common.days')}`}
        </Typography>
    );
};
